/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import { useLayoutEffect, useEffect } from 'react';
import { canUseDocument } from './dom.js';
import 'raf';
import '../_chunks/dep-10140b37.js';
import '../_chunks/dep-7a9656a6.js';
import '../_chunks/dep-da112583.js';
import '../_chunks/dep-dfae10c3.js';
import '../_chunks/dep-1792ab93.js';
import '../_chunks/dep-1e4c771d.js';
import './easing.js';

var useIsomorphicLayoutEffect = canUseDocument ? useLayoutEffect : useEffect;

export { useIsomorphicLayoutEffect as default };
//# sourceMappingURL=useLayoutEffect.js.map
